// tslint:disable
/**
 * Scorm API
 * Used for: - Manage SCORM - Import courses - Learning control 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { Commit } from '../models';
import { ScormLaunch } from '../models';
import { Session } from '../models';
/**
 * ScormLearningProgressApi - axios parameter creator
 * @export
 */
export const ScormLearningProgressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Commit SCORM\'s SCO.
         * @param {string} id 
         * @param {string} learningUnitId 
         * @param {Commit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitScorm(id: string, learningUnitId: string, body: Commit, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling commitScorm.');
            }
            // verify required parameter 'learningUnitId' is not null or undefined
            if (learningUnitId === null || learningUnitId === undefined) {
                throw new RequiredError('learningUnitId','Required parameter learningUnitId was null or undefined when calling commitScorm.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling commitScorm.');
            }
            const localVarPath = `/course/{id}/learning-unit/{learningUnitId}/scorm/commit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"learningUnitId"}}`, encodeURIComponent(String(learningUnitId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Finish SCORM\'s SCO.
         * @param {string} id 
         * @param {string} learningUnitId 
         * @param {Session} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishScorm(id: string, learningUnitId: string, body: Session, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling finishScorm.');
            }
            // verify required parameter 'learningUnitId' is not null or undefined
            if (learningUnitId === null || learningUnitId === undefined) {
                throw new RequiredError('learningUnitId','Required parameter learningUnitId was null or undefined when calling finishScorm.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling finishScorm.');
            }
            const localVarPath = `/course/{id}/learning-unit/{learningUnitId}/scorm/finish`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"learningUnitId"}}`, encodeURIComponent(String(learningUnitId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initialize SCORM\'s SCO.
         * @param {string} id 
         * @param {string} learningUnitId 
         * @param {Session} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializeScorm(id: string, learningUnitId: string, body: Session, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling initializeScorm.');
            }
            // verify required parameter 'learningUnitId' is not null or undefined
            if (learningUnitId === null || learningUnitId === undefined) {
                throw new RequiredError('learningUnitId','Required parameter learningUnitId was null or undefined when calling initializeScorm.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling initializeScorm.');
            }
            const localVarPath = `/course/{id}/learning-unit/{learningUnitId}/scorm/initialize`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"learningUnitId"}}`, encodeURIComponent(String(learningUnitId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Launch SCORM\'s SCO.
         * @param {string} id 
         * @param {string} learningUnitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        launchScorm(id: string, learningUnitId: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling launchScorm.');
            }
            // verify required parameter 'learningUnitId' is not null or undefined
            if (learningUnitId === null || learningUnitId === undefined) {
                throw new RequiredError('learningUnitId','Required parameter learningUnitId was null or undefined when calling launchScorm.');
            }
            const localVarPath = `/course/{id}/learning-unit/{learningUnitId}/scorm/launch`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"learningUnitId"}}`, encodeURIComponent(String(learningUnitId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScormLearningProgressApi - functional programming interface
 * @export
 */
export const ScormLearningProgressApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Commit SCORM\'s SCO.
         * @param {string} id 
         * @param {string} learningUnitId 
         * @param {Commit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitScorm(id: string, learningUnitId: string, body: Commit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = ScormLearningProgressApiAxiosParamCreator(configuration).commitScorm(id, learningUnitId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Finish SCORM\'s SCO.
         * @param {string} id 
         * @param {string} learningUnitId 
         * @param {Session} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishScorm(id: string, learningUnitId: string, body: Session, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = ScormLearningProgressApiAxiosParamCreator(configuration).finishScorm(id, learningUnitId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Initialize SCORM\'s SCO.
         * @param {string} id 
         * @param {string} learningUnitId 
         * @param {Session} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializeScorm(id: string, learningUnitId: string, body: Session, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = ScormLearningProgressApiAxiosParamCreator(configuration).initializeScorm(id, learningUnitId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Launch SCORM\'s SCO.
         * @param {string} id 
         * @param {string} learningUnitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        launchScorm(id: string, learningUnitId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScormLaunch> {
            const localVarAxiosArgs = ScormLearningProgressApiAxiosParamCreator(configuration).launchScorm(id, learningUnitId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ScormLearningProgressApi - factory interface
 * @export
 */
export const ScormLearningProgressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Commit SCORM\'s SCO.
         * @param {string} id 
         * @param {string} learningUnitId 
         * @param {Commit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitScorm(id: string, learningUnitId: string, body: Commit, options?: any) {
            return ScormLearningProgressApiFp(configuration).commitScorm(id, learningUnitId, body, options)(axios, basePath);
        },
        /**
         * Finish SCORM\'s SCO.
         * @param {string} id 
         * @param {string} learningUnitId 
         * @param {Session} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishScorm(id: string, learningUnitId: string, body: Session, options?: any) {
            return ScormLearningProgressApiFp(configuration).finishScorm(id, learningUnitId, body, options)(axios, basePath);
        },
        /**
         * Initialize SCORM\'s SCO.
         * @param {string} id 
         * @param {string} learningUnitId 
         * @param {Session} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializeScorm(id: string, learningUnitId: string, body: Session, options?: any) {
            return ScormLearningProgressApiFp(configuration).initializeScorm(id, learningUnitId, body, options)(axios, basePath);
        },
        /**
         * Launch SCORM\'s SCO.
         * @param {string} id 
         * @param {string} learningUnitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        launchScorm(id: string, learningUnitId: string, options?: any) {
            return ScormLearningProgressApiFp(configuration).launchScorm(id, learningUnitId, options)(axios, basePath);
        },
    };
};

/**
 * ScormLearningProgressApi - object-oriented interface
 * @export
 * @class ScormLearningProgressApi
 * @extends {BaseAPI}
 */
export class ScormLearningProgressApi extends BaseAPI {
    /**
     * Commit SCORM\'s SCO.
     * @param {string} id 
     * @param {string} learningUnitId 
     * @param {Commit} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormLearningProgressApi
     */
    public commitScorm(id: string, learningUnitId: string, body: Commit, options?: any) {
        return ScormLearningProgressApiFp(this.configuration).commitScorm(id, learningUnitId, body, options)(this.axios, this.basePath);
    }

    /**
     * Finish SCORM\'s SCO.
     * @param {string} id 
     * @param {string} learningUnitId 
     * @param {Session} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormLearningProgressApi
     */
    public finishScorm(id: string, learningUnitId: string, body: Session, options?: any) {
        return ScormLearningProgressApiFp(this.configuration).finishScorm(id, learningUnitId, body, options)(this.axios, this.basePath);
    }

    /**
     * Initialize SCORM\'s SCO.
     * @param {string} id 
     * @param {string} learningUnitId 
     * @param {Session} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormLearningProgressApi
     */
    public initializeScorm(id: string, learningUnitId: string, body: Session, options?: any) {
        return ScormLearningProgressApiFp(this.configuration).initializeScorm(id, learningUnitId, body, options)(this.axios, this.basePath);
    }

    /**
     * Launch SCORM\'s SCO.
     * @param {string} id 
     * @param {string} learningUnitId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormLearningProgressApi
     */
    public launchScorm(id: string, learningUnitId: string, options?: any) {
        return ScormLearningProgressApiFp(this.configuration).launchScorm(id, learningUnitId, options)(this.axios, this.basePath);
    }

}
